import { useEffect, useState } from 'react';

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState('');
  const [wechatOpen, setWechatOpen] = useState(false);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(''), 2400);
    return () => window.clearTimeout(timer);
  }, [toast]);

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setWechatOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast('链接已复制，可粘贴给同好');
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(textarea);
      setToast(ok ? '链接已复制，可粘贴给同好' : '复制失败，请手动复制地址栏链接');
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-secondary-500 mr-1 whitespace-nowrap">分享</span>
      <button
        type="button"
        onClick={copyLink}
        className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-md border border-background-200 bg-background-50 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-link w-4 h-4 flex items-center justify-center"></i>
        复制链接
      </button>
      <button
        type="button"
        onClick={() => setWechatOpen(true)}
        className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-md border border-background-200 bg-background-50 text-xs text-foreground-700 hover:border-accent-300 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-wechat-line w-4 h-4 flex items-center justify-center"></i>
        微信分享
      </button>

      {toast && (
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-primary-50 text-primary-700 text-xs animate-fade-in">
          <i className="ri-checkbox-circle-line w-3.5 h-3.5 flex items-center justify-center"></i>
          {toast}
        </span>
      )}

      {wechatOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
          <button
            type="button"
            aria-label="关闭分享弹窗"
            onClick={() => setWechatOpen(false)}
            className="absolute inset-0 bg-primary-950/60 backdrop-blur-sm cursor-pointer"
          ></button>
          <div className="relative w-full max-w-sm rounded-lg bg-background-50 border border-background-200 p-6 animate-fade-up">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="text-base font-semibold">微信分享</h3>
                <p className="mt-1 text-xs text-secondary-500 leading-5">在微信内打开本站链接，即可分享给好友或群聊。</p>
              </div>
              <button
                type="button"
                aria-label="关闭"
                onClick={() => setWechatOpen(false)}
                className="w-8 h-8 rounded-md border border-background-200 text-secondary-500 flex items-center justify-center hover:text-foreground-900 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-base"></i>
              </button>
            </div>
            <div className="mt-5 rounded-lg border border-dashed border-background-300 bg-background-100 p-6 flex flex-col items-center text-center">
              <div className="w-14 h-14 rounded-full bg-[#07c160]/10 flex items-center justify-center">
                <i className="ri-wechat-fill text-3xl text-[#07c160]"></i>
              </div>
              <p className="mt-3 text-sm text-foreground-800">{title}</p>
              <p className="mt-1 text-xs text-secondary-500">打开微信 → 扫一扫 → 分享给好友</p>
            </div>
            <button
              type="button"
              onClick={copyLink}
              className="mt-4 w-full h-10 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              复制页面链接
            </button>
          </div>
        </div>
      )}
    </div>
  );
}